<template>
  <v-dialog v-model="mappeddialog" width="500px">
    <v-card class="overflow-hidden">
      <v-toolbar dark class="primary" dense>
        <v-toolbar-title>Edit</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn class text dark @click="mappeddialog = false">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-row class="mt-5 mx-2">
        <!-- <v-text-field
          label="Proxy Number"
          v-model="proxy"
          dense
          disabled
          outlined
        ></v-text-field> -->
      </v-row>
      <v-row class="mx-2">
        <v-text-field label="Name" v-model="name" dense outlined></v-text-field>
      </v-row>
      <v-row class="mx-2">
        <v-text-field
          label="Contact Number"
          v-model="phno"
          dense
          outlined
        ></v-text-field>
      </v-row>

      <v-card-actions>
        <v-spacer />
        <v-btn class="primary" @click="mappeddialog = false">
          <v-icon>mdi-save</v-icon>Save changes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    mappeddialog: false,
    departmrnts: ["sales", "marketing"],
    proxy: null,
    name: null,
    phno: null,
  }),
};
</script>

<style>
</style>